import { PlanRow } from "./subscription.interface";

export { PlanRow } from "./subscription.interface";

export const FEATURE_ROWS: PlanRow[] = [
  {
    feature: "subscription.features.optionsPlan",
    basic: "0.99",
    premium: "1.99",
  },
  {
    feature: "subscription.features.licenses",
    basic: "Min 10",
    premium: "Min 10",
  },
  {
    feature: "subscription.features.emailMessageTemplates",
    basic: "subscription.limits.templates10",
    premium: "subscription.unlimited",
  },
  {
    feature: "subscription.features.adminAccounts",
    basic: "subscription.limits.admins3",
    premium: "subscription.unlimited",
  },
  {
    feature: "subscription.features.analyticsModule",
    basic: "",
    premium: "yes",
  },
  {
    feature: "subscription.features.customTemplateDesign",
    basic: "",
    premium: "yes",
  },
  {
    feature: "subscription.features.dynamicTemplatesRules",
    basic: "",
    premium: "yes",
  },
  {
    feature: "subscription.features.onPremisesOutlook",
    basic: "",
    premium: "yes",
  },
  { feature: "subscription.features.restApi", basic: "", premium: "yes" },
  {
    feature: "subscription.features.serverSideSignatures",
    basic: "",
    premium: "yes",
  },
  {
    feature: "subscription.features.internalExternalSignatures",
    basic: "",
    premium: "yes",
  },
  {
    feature: "subscription.features.customVariables",
    basic: "subscription.limits.variables10",
    premium: "subscription.unlimited",
  },
  {
    feature: "subscription.features.marketingBannersButtons",
    basic: "subscription.limits.banners2",
    premium: "subscription.unlimited",
  },
  {
    feature: "subscription.features.additionalDomainsSubdomains",
    basic: "subscription.limits.domains1",
    premium: "subscription.unlimited",
  },
  {
    feature: "subscription.features.mediaHosting",
    basic: "subscription.limits.hosting5mb",
    premium: "subscription.unlimited",
  },
  {
    feature: "subscription.features.complexNeedsDiscoveryMin100",
    basic: "",
    premium: "yes",
  },
  {
    feature: "subscription.features.corporateIntegrationsMin100",
    basic: "",
    premium: "yes",
  },
  {
    feature: "subscription.features.delegatedManagementMin100",
    basic: "",
    premium: "yes",
  },
  { feature: "subscription.keyFeaturesInDetail", basic: "-", premium: "-" },
  {
    feature: "subscription.features.chatMailSupport",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.updateScheduling",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.disclaimerManagement",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.automaticDataUpdates",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.selfApprovalUpdates",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.htmlContent",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.numberFormatting",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.automaticFooter",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.outOfOffice",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.centralizedManagement",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.chromeEdgeExtension",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.csvImportExport",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.dataImportExportManager",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.employeeDataManager",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.employeeDirectory",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.templateLibrary",
    basic: "yes",
    premium: "yes",
  },
  { feature: "subscription.features.fullAccess", basic: "yes", premium: "yes" },
  { feature: "subscription.features.geminiAI", basic: "yes", premium: "yes" },
  {
    feature: "subscription.features.googleIntegration",
    basic: "yes",
    premium: "yes",
  },
  { feature: "subscription.features.hrBadges", basic: "yes", premium: "yes" },
  {
    feature: "subscription.features.calamariIntegration",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.microsoftIntegration",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.outlookAddin",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.remoteRemoval",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.aliasesGroups",
    basic: "yes",
    premium: "yes",
  },
  {
    feature: "subscription.features.templateCustomization",
    basic: "yes",
    premium: "yes",
  },
];
